define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TimeOfDayDomain = void 0;
    class TimeOfDayDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: TimeOfDayDomain.Am, value: "AM" },
                    { key: TimeOfDayDomain.Pm, value: "PM" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[TimeOfDayDomain.Am] = 0;
                this.KeyIndex[TimeOfDayDomain.Pm] = 1;
                this.ValueIndex = {};
                this.ValueIndex["AM"] = 0;
                this.ValueIndex["PM"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.TimeOfDayDomain = TimeOfDayDomain;
    Object.defineProperty(TimeOfDayDomain, "Am", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "AM"
    });
    Object.defineProperty(TimeOfDayDomain, "Pm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PM"
    });
    Object.defineProperty(TimeOfDayDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
